
// SEO utilities for dynamic meta tags and structured data
export interface SEOData {
  title: string;
  description: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

export function updateSEO(data: SEOData) {
  // Update document title
  document.title = data.title;

  // Update meta description
  updateMetaTag('description', data.description);
  
  // Update keywords if provided
  if (data.keywords) {
    updateMetaTag('keywords', data.keywords);
  }

  // Update Open Graph tags
  updateMetaTag('og:title', data.title, 'property');
  updateMetaTag('og:description', data.description, 'property');
  updateMetaTag('og:type', data.type || 'website', 'property');
  
  if (data.image) {
    updateMetaTag('og:image', data.image, 'property');
  }
  
  if (data.url) {
    updateMetaTag('og:url', data.url, 'property');
  }

  // Update Twitter tags
  updateMetaTag('twitter:title', data.title, 'name');
  updateMetaTag('twitter:description', data.description, 'name');
  updateMetaTag('twitter:card', 'summary_large_image', 'name');
}

function updateMetaTag(name: string, content: string, attribute: string = 'name') {
  let element = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement;
  
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  
  element.setAttribute('content', content);
}

export function addJSONLD(data: object) {
  // Remove existing JSON-LD scripts for the same type
  const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
  existingScripts.forEach(script => {
    try {
      const existingData = JSON.parse(script.textContent || '');
      const newData = data as any;
      if (existingData['@type'] === newData['@type']) {
        script.remove();
      }
    } catch (e) {
      // Invalid JSON, remove it
      script.remove();
    }
  });

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}
